import { connect, ConnectedProps } from 'react-redux'
import ContentComponent from 'components/accordion/ContentComponent'
import { RootState } from 'redux/store'

const mapStateToProps = (state: RootState): { flavour: RootState['layout']['flavour'] } => ({
  flavour: state.layout.flavour
})

export const connector = connect(mapStateToProps, null)
export type ContentContainerProps = ConnectedProps<typeof connector>

export default connect(mapStateToProps, null)(ContentComponent)
